import React, { useEffect, useRef, useState } from 'react'
import cx from 'classnames'

import {
  useRecordingPlaybackState,
  useRecordingPlaybackStateObserver
} from '../../hooks'

export const Seeker = () => {
  const sliderElem = useRef(null)
  const [interacting, setInteracting] = useState(false)
  const { elapsed, genesis, terminus, loading } = useRecordingPlaybackState()
  const playbackStateObserverRef = useRecordingPlaybackStateObserver()

  useEffect(() => {
    if (!sliderElem.current || interacting) return

    sliderElem.current.value = elapsed
  }, [elapsed, interacting])

  return (
    <div className='gp-Recording-slider-wrapper'>
      <input
        ref={sliderElem}
        disabled={loading}
        type='range'
        className={cx('gp-Recording-slider', {
          'gp-Recording-slider--disabled': loading
        })}
        min={0}
        max={terminus - genesis}
        step={2000}
        onMouseDown={() => {
          setInteracting(true)
        }}
        onMouseUp={(e) => {
          setInteracting(false)
          playbackStateObserverRef.current.seek(Number(e.target.value))
        }}
      />
    </div>
  )
}
